import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Logo1 from '../Assets/logo1.png';
import './Navbar.css';

function Navbar() {
    const [menuOpen, setMenuOpen] = useState(false);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const navigate = useNavigate();

    const handleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    const closeMenu = () => {
        setMenuOpen(false);
    };

    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };

    const handleSearchSubmit = (e) => {
        e.preventDefault();
        if (searchQuery.trim() !== '') {
            navigate(`/search?query=${searchQuery}`);
            setSearchQuery('');
            closeMenu();
        }
    };

    return (
        <nav className="navbar">
            <div className="navbar-container">
                <Link to="/" className="navbar-logo">
                    <img src={Logo1} alt="Logo" />
                </Link>
                <div className={`menu-icon ${menuOpen ? 'active' : ''}`} onClick={handleMenu}>
                    <i className={menuOpen ? 'fas fa-times' : 'fas fa-bars'}></i>
                </div>
                <ul className={`nav-menu ${menuOpen ? 'active' : ''}`}>
                    <li className="nav-item">
                        <Link to="/" className="nav-links" onClick={closeMenu}>
                            Home
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link to="/movies" className="nav-links" onClick={closeMenu}>
                            Movies
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link to="/tv-shows" className="nav-links" onClick={closeMenu}>
                            TV Shows
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link to="/my-list" className="nav-links" onClick={closeMenu}>
                            My List
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link to="/movie-list" className="nav-links" onClick={closeMenu}>
                            Movie List
                        </Link>
                    </li>

                    <form className="nav-search" onSubmit={handleSearchSubmit}>
                    <input
                        type="text"
                        placeholder="Search"
                        value={searchQuery}
                        onChange={handleSearchChange}
                    />
                    <button type="submit"><i className="fas fa-search"></i></button>
                </form>
                </ul>
                <div className="nav-search-profile">
      
                    <div className="nav-profile" onClick={toggleDropdown}>
                        <i className="fas fa-user-circle"></i>
                        {dropdownOpen && (
                            <ul className="dropdown-menu">
                                <li><Link to="/profile" onClick={() => setDropdownOpen(false)}>Profile</Link></li>
                                <li><Link to="/settings" onClick={() => setDropdownOpen(false)}>Settings</Link></li>
                                <li><Link to="/logout" onClick={() => setDropdownOpen(false)}>Logout</Link></li>
                            </ul>
                        )}
                    </div>
                </div>
            </div>
        </nav>
    );
}

export default Navbar;
